export const csvParser = (csv) => {
  try {
    var lines = csv.split('\n');
    var result = [];
    var headers = lines[0].split(',');

    for (var index = 1; index < lines.length; index++) {
      var objectItem = {};
      var currentline = lines[index].split(',');
      for (var headerIndex = 0; headerIndex < headers.length; headerIndex++) {
        objectItem[headers[headerIndex]] = currentline[headerIndex];
      }
      result.push(objectItem);
    }

    return result;
  } catch (error) {
    return [];
  }
};
